module.exports = __webpack_public_path__ + "static/img/设计市场.f89b158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计市场.png
// module id = IzfA
// module chunks = 1